import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDashboardContext } from "./DashboardProvider";
import { useLangContext } from "context/Lang";
import { routes } from "routes";
import { Loader } from "components/Loader/Loader";
import { motion } from "framer-motion";
import { Map, ExternalLink, ShieldCheck, Users, BuildingIcon, LayoutGridIcon } from "lucide-react";
import { Button } from "components/Button/Button";
import { ReplaceWords } from "utils/ReplaceWords";

export const DashboardPage = () => {
    const { counts, loading, getDashboard } = useDashboardContext();
    const { gW } = useLangContext();
    const navigate = useNavigate();

    useEffect(() => {
        getDashboard?.();
    }, []);


    if (loading) return <div className="flex justify-center p-20"><Loader /></div>;

  

    return (
        <motion.div 
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: 1, y: 0 }}
            className="p-6"
        >
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-primary-800">{gW("dashboard-overview")}</h1>
                    <p className="text-primary-500">{gW("track-your-system-analytics")}</p>
                </div>
                <div className="bg-primary-100 p-2 rounded-lg">
                    <ShieldCheck className="text-primary-600" size={24} />
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                
                {counts?.numberOfItemEditor!==undefined&&<div onClick={()=>{navigate( ReplaceWords(routes.dashboardRroute,{route:routes.dashboardRroutes.assignedBuildings}))}}    className="bg-white select-none  cursor-pointer  rounded-2xl border border-primary-100 p-5 shadow-sm hover:shadow-md transition-shadow flex items-center gap-4">
                    <div className="bg-primary-50 p-3 rounded-xl text-primary-600">
                        <BuildingIcon size={24} />
                    </div>
                    <div>
                        <p className="text-xs font-bold text-primary-400 uppercase tracking-wider">
                            {gW("number-of-assigned-buildings")}
                        </p>
                        <h3 className="text-2xl font-black text-primary-800 mt-0.5">
                            {counts?.numberOfItemEditor ?? 0}
                        </h3>
                    </div>
                </div>}

                {/* {counts?.numberOfActiveItemEditor !== undefined && (
                    <div 
                        className="bg-white select-none cursor-pointer rounded-2xl border border-green-100 p-5 shadow-sm hover:shadow-md transition-shadow flex items-center gap-4"
                    >
                        <div className="bg-green-50 p-3 rounded-xl text-green-600">
                            <BuildingIcon size={24} /> 
                        </div>
                        <div>
                            <p className="text-xs font-bold text-green-400 uppercase tracking-wider">
                                {gW("number-of-activated-buildings")}
                            </p>
                            <h3 className="text-2xl font-black text-green-800 mt-0.5">
                                {counts?.numberOfActiveItemEditor ?? 0}
                            </h3>
                        </div>
                    </div>
                )} */}


                {/* الكرت الثاني: عدد محرري الخرائط (numberOfMapEditor) */}
                {counts?.numberOfMapEditor !== undefined && (
                    <div 
                        onClick={()=>{navigate( ReplaceWords(routes.dashboardRroute,{route:routes.dashboardRroutes.assignedMaps}))}}
                        className="bg-white select-none cursor-pointer rounded-2xl border border-primary-100 p-5 shadow-sm hover:shadow-md transition-shadow flex items-center gap-4"
                    >
                        <div className="bg-primary-50 p-3 rounded-xl text-primary-600">
                            <Map size={24} /> {/* أو أيقونة Users حسب رغبتك البصرية */}
                        </div>
                        <div>
                            <p className="text-xs font-bold text-primary-400 uppercase tracking-wider">
                                {gW("number-of-assigned-maps")}
                            </p>
                            <h3 className="text-2xl font-black text-primary-800 mt-0.5">
                                {counts?.numberOfMapEditor ?? 0}
                            </h3>
                        </div>
                    </div>
                )}

                {/* الكرت الثالث: عدد العناصر المنشأة بالمحرر (numberOfCreateItemEditor) */}
                {counts?.numberOfCreateItemEditor !== undefined && (
                    <div 
                        onClick={()=>{navigate( ReplaceWords(routes.dashboardRroute,{route:routes.dashboardRroutes.buildings}))}}
  
                        className="bg-white select-none cursor-pointer rounded-2xl border border-primary-100 p-5 shadow-sm hover:shadow-md transition-shadow flex items-center gap-4"
                    >
                        <div className="bg-primary-50 p-3 rounded-xl text-primary-600">
                            <LayoutGridIcon size={24} /> {/* أيقونة تعبر عن العناصر والمجسمات */}
                        </div>
                        <div>
                            <p className="text-xs font-bold text-primary-400 uppercase tracking-wider">
                                {gW("number-of-created-building-editor")}
                            </p>
                            <h3 className="text-2xl font-black text-primary-800 mt-0.5">
                                {counts?.numberOfCreateItemEditor ?? 0}
                            </h3>
                        </div>
                    </div>
                )}



                {/* يمكنك إضافة كروت عدادات أخرى هنا مستقبلاً بنفس الستايل عند توسيع الـ API */}

            </div>
        </motion.div>
    );
};